/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import addressActions from "../../../../Admin/Address/redux/actions";
import globalAddressActions from "../../../../Admin/Home/redux/actions";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import { getRequest } from '../../../../../helpers/axiosClient';
import customStyles from "../../../../../assets/styles/customStyles";
import DateIcon from "../../Icons/Date";
import { emptyValidation } from "../../../../../helpers/validation";
import { SelectedIcon, UnSelectedIcon } from "../../Icons/selectedIcon";
import moment from 'moment';
import { Button, Box, Radio, RadioGroup, FormControlLabel, Switch, FormControl, FormLabel } from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';


export const StaffSalesCollectionStatement = (props) => {
    const { visible, onStaffSalesCollectionVisible, title, onMenuTitle } = props;
    const { pincodeDetails } = useSelector(state => state.addressReducer);

    const { businessDetails, getTeamData } = useSelector(state => state.homeReducer);
    const [reportOpen, setReportOpen] = useState(false);
    const [filterValues, setFilterValues] = useState({
        reportType: 'summary',
        type: 'invoice',
        startDate: new Date(),
        balance: false,
        endDate: new Date()
    });
    const [collectionData, setCollectionData] = useState([]);
    const [errorDateFilter, setErrorDateFilter] = useState('');
    const [errorSalesRep, setErrorSalesRep] = useState('');

    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    useEffect(() => {
        if (visible) {
            dispatch({
                type: globalAddressActions.TEAM_DETAILS_START, url: 'team', filter: {
                    order: 'id  desc'
                }
            });
            pincodeApi();
        }
    }, [visible])

    const salesPaymentFilter = (e) => {
        e.preventDefault();
        let emptyDateFilter = emptyValidation('Date Filter', filterValues?.dateFilter, 'dropDown');
        let emptySalesRep = emptyValidation('Sales Rep', filterValues?.salesRep?.id, 'dropDown');
        // let emptyProductAnalysisValue = emptyValidation('Product Analysis', productAnalysisValue, 'dropDown');

        if (emptyDateFilter.isValid && emptySalesRep.isValid) {
            setLoading(true);
            try {
                let url = `?reportType=${filterValues?.reportType}`;

                if (filterValues?.type) {
                    url += `&type=${filterValues?.type}`;
                }

                if (filterValues?.salesRep?.id) {
                    url += `&salesRepId=${filterValues?.salesRep?.id}`;
                }

                if (filterValues?.pincode?.id) {
                    url += `&pincodeId=${filterValues?.pincode?.id}`;
                }

                if (!filterValues?.balance) {
                    url += `&balance=yes`;
                }

                if (filterValues?.dateFilter) {
                    const prefix = url === '' ? '?' : '&';
                    const today = moment().format("YYYY-MM-DD");

                    const getLastDays = (days) => {
                        return moment().subtract(days - 1, 'days').format("YYYY-MM-DD");
                    };

                    switch (filterValues.dateFilter) {
                        case 'today':
                            url += `${prefix}startDate=${today}&endDate=${today}`;
                            break;

                        case 'last_7':
                            url += `${prefix}startDate=${getLastDays(7)}&endDate=${today}`;
                            break;

                        case 'last_14':
                            url += `${prefix}startDate=${getLastDays(14)}&endDate=${today}`;
                            break;

                        case 'last_20':
                            url += `${prefix}startDate=${getLastDays(20)}&endDate=${today}`;
                            break;

                        case 'custom':
                            url += `${prefix}startDate=${moment(filterValues?.startDate).format("YYYY-MM-DD")}&endDate=${moment(filterValues?.endDate).format("YYYY-MM-DD")}`;
                            break;

                        default:
                            break;
                    }
                }

                let response = getRequest(`${process.env.REACT_APP_API_URL}/staffSalesCollection${url}`);
                response.then(payload => {
                    setCollectionData(payload.data);
                    setReportOpen(true);
                    setLoading(false);
                }).catch(error => {
                    // Handle any errors
                    setLoading(false);
                })
            } catch (error) {
                setLoading(false);
            }
        } else {
            if (emptyDateFilter.errors !== '') {
                setErrorDateFilter(emptyDateFilter.errors);
            }
            if (emptySalesRep.errors !== '') {
                setErrorSalesRep(emptySalesRep.errors);
            }
        }
    }

    const pincodeApi = (search = '', id = '') => {
        let filter = { or: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const handleClose = () => {
        onMenuTitle('');
        onStaffSalesCollectionVisible(false);
        setFilterValues({
            reportType: 'summary',
            type: 'invoice',
            startDate: new Date(),
            endDate: new Date(),
            balance: false
        });
        setErrorDateFilter('');
        setErrorSalesRep('');
    }

    const classes = customStyles();

    const changeHandler = (e, name = '') => {
        setFilterValues({
            ...filterValues,
            [name]: e
        });
    }

    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => salesPaymentFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <FormControl
                                tabIndex={-1}
                                className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                variant={'standard'}
                                fullWidth
                                style={{ paddingLeft: 5 }}>
                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Report Type</FormLabel>
                                <RadioGroup
                                    row
                                    defaultValue={"reportType"}
                                    value={filterValues?.reportType}
                                    onChange={(e) => changeHandler(e.target.value, 'reportType')}>
                                    <FormControlLabel value="summary" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Summary" />
                                    <FormControlLabel value="details" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Details" />
                                </RadioGroup>
                            </FormControl>
                            <AutoCompleteComponent
                                name={["Sales Rep  ", <span key="Sales Rep " className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE')}
                                parentValue={customObject(getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE'), filterValues?.salesRep?.id)}
                                onChange={(data) => changeHandler(data, 'salesRep')}
                                id={idNamingConversion('Sales Rep Id', 'customerProfile', 'DropDown')}
                                onChangeText={(value) => {
                                    if (value === '') {
                                        changeHandler('', 'salesRep');
                                    }
                                }}
                                parentError={errorSalesRep}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                            />
                            <AutoCompleteComponent
                                name={["Pincode "]}
                                heads={[{ 'key': 'code', 'name': 'Pincode' },
                                { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                details={pincodeDetails}
                                id={idNamingConversion('Pincode', 'salesPaymentStatement', 'DropDown')}
                                parentValue={customObject(pincodeDetails, filterValues?.pincode?.id)}
                                onChange={(data) => changeHandler(data, 'pincode')}
                                searchType={(s) => pincodeApi(s)}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                            />
                            <AutoCompleteComponent
                                name={["Date Filter ", <span key="Date Filter" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'Date Filter' }]}
                                details={[{ "id": "today", "label": "Today" }, { "id": "last_7", "label": "Last 7 Days" }, { "id": "last_14", "label": "Last 14 Days" }, { "id": "last_20", "label": "Last 20 Days" }, { "id": "custom", "label": "Custom" }]}
                                parentValue={customObject([{ "id": "today", "label": "Today" }, { "id": "last_7", "label": "Last 7 Days" }, { "id": "last_14", "label": "Last 14 Days" }, { "id": "last_20", "label": "Last 20 Days" }, { "id": "custom", "label": "Custom" }], filterValues?.dateFilter)}
                                onChange={(data) => changeHandler(data.id, 'dateFilter')}
                                position={'bottom'}
                                id={idNamingConversion('Date Filter', 'salesPaymentStatement', 'DropDown')}
                                parentError={errorDateFilter}
                                customClasses={classes.margin30t}
                            />
                            {
                                filterValues?.dateFilter === 'custom' ? <>
                                    <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={filterValues?.startDate}
                                                format='dd/MM/yyyy'
                                                label="Start Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('Start Date', 'salesPaymentStatement', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // readOnly={true}
                                                onChange={(newValue) => {
                                                    (newValue === null || newValue === 'Invalid Date') ?
                                                        changeHandler(new Date(), 'startDate') : changeHandler(newValue, 'startDate')
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={filterValues?.endDate}
                                                format='dd/MM/yyyy'
                                                label="End Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('End Date', 'salesPaymentStatement', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // readOnly={true}
                                                onChange={(newValue) => {
                                                    (newValue === null || newValue === 'Invalid Date') ?
                                                        changeHandler(new Date(), 'endDate') : changeHandler(newValue, 'endDate')
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </> : null
                            }
                            <FormControl
                                tabIndex={-1}
                                className={clsx(classes.dropDownPointer, classes.margin30t, classes.customRadioButton, classes.customIdentityRadioButton)}
                                variant={'standard'}
                                fullWidth
                                style={{ paddingLeft: 5 }}>
                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Type</FormLabel>
                                <RadioGroup
                                    row
                                    defaultValue={"type"}
                                    value={filterValues?.type}
                                    onChange={(e) => changeHandler(e.target.value, 'type')}>
                                    <FormControlLabel value="invoice" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Invoice" />
                                    <FormControlLabel value="payment" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Payment" />
                                </RadioGroup>
                            </FormControl>
                            <FormControlLabel
                                classes={{
                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                }}
                                id={idNamingConversion('Hold', 'customerProfile', 'Radio')}
                                control={<Switch size='small'
                                    className={clsx(classes.customSwitch)}
                                    onChange={(e) => changeHandler(!filterValues.balance, 'balance')}
                                    checked={filterValues.balance}
                                />}
                                label="Include Zero Balance"
                                labelPlacement="top"
                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}>{ } { }</p>

                        </div>
                        {console.log(collectionData)}
                        {
                            filterValues?.reportType === 'details' ? <>
                                {
                                    collectionData && Object.keys(collectionData).length > 0 ? (
                                        Object.entries(collectionData).map(([customerId, txList]) => {

                                            const firstTx = txList[0]; // ✅ first transaction of this customer

                                            return (
                                                <>
                                                    <Row key={customerId} className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, "no-break")}                                                >
                                                        <Col span={24}><h6 style={{ color: "#000" }}>{firstTx?.customer?.serialNo + " - " || "-"} {firstTx?.customer?.name + " - " || "-"} {firstTx?.customer?.area?.name ? firstTx?.customer?.area?.name + " - " : "-"}  {firstTx?.customer?.pincode?.code ? firstTx?.customer?.pincode?.code : "-"}</h6></Col>
                                                    </Row>
                                                    {
                                                        filterValues?.type === 'invoice' ? <>
                                                            <Row className={clsx(classes.bill, classes.billReportHead, classes.margin10t, classes.viewPrint, 'no-break')}>
                                                                <Col span={6}><h6>Date </h6></Col>
                                                                <Col span={6}><h6>Invoice Number</h6></Col>
                                                                <Col span={6} className={classes.textAlignRight}><h6>Amount </h6></Col>
                                                                <Col span={6} className={classes.textAlignRight}><h6>Balance </h6></Col>
                                                            </Row>
                                                            {
                                                                txList.length > 0 ? txList.map((data, i) => (
                                                                    <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                                                        <Col span={6}><p>{moment(data.date).format("YYYY-MM-DD")}</p></Col>
                                                                        <Col span={6}><p>{data?.salesInvoice?.serialNo || '---'}</p></Col>
                                                                        <Col span={6} className={classes.textAlignRight}><p>₹ {currencyFormat(data.amount)}</p></Col>
                                                                        <Col span={6} className={classes.textAlignRight}><p>₹ {currencyFormat(data.balance)}</p></Col>
                                                                    </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                                            }
                                                        </> : <>
                                                            <Row className={clsx(classes.bill, classes.billReportHead, classes.margin10t, classes.viewPrint, 'no-break')}>
                                                                <Col span={6}><h6>Payment date </h6></Col>
                                                                <Col span={6}><h6>Paid Amount</h6></Col>
                                                                <Col span={6} className={classes.textAlignRight}><h6>Settled Invoice </h6></Col>
                                                                <Col span={6} className={classes.textAlignRight}><h6>Balance amount </h6></Col>
                                                            </Row>
                                                            {
                                                                txList.length > 0 ? txList.map((data, i) => (
                                                                    <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                                                        <Col span={6}><p>{moment(data.date).format("YYYY-MM-DD")}</p></Col>
                                                                        <Col span={6}><p>₹ {currencyFormat(data.amount)}</p></Col>
                                                                        <Col span={6} className={classes.textAlignRight}><p>{data?.customerPayment?.customerPaymentItems
                                                                            ?.map((el) => el?.salesInvoice?.serialNo)
                                                                            .filter(Boolean)
                                                                            .join(", ") || "-"}</p></Col>
                                                                        <Col span={6} className={classes.textAlignRight}><p>₹ {currencyFormat(data.balance)}</p></Col>
                                                                    </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                                            }
                                                        </>
                                                    }

                                                </>
                                            );
                                        })
                                    ) : (
                                        <Row className={classes.noBorder}>
                                            <Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col>
                                        </Row>
                                    )
                                }
                            </> : <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={4}><h6>Customer ID</h6></Col>
                                    <Col span={5}><h6>Customer Name</h6></Col>
                                    <Col span={4}><h6>Area</h6></Col>
                                    <Col span={3}><h6>Pincode</h6></Col>
                                    {
                                        filterValues?.type === 'invoice' ? <Col span={3}><h6 className={classes.textAlignRight}>Amount</h6></Col> : ''
                                    }
                                    <Col span={filterValues?.type === 'invoice' ? 5 : 8} ><h6 className={classes.textAlignRight}>{filterValues?.type === 'payment' ? 'Collection amount' : 'Balance'}</h6></Col>
                                </Row>
                                {
                                    collectionData.length > 0 ? collectionData.map((data, i) => (
                                        <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                            <Col span={4}><p>{data.serialNo}</p></Col>
                                            <Col span={5}><p>{data.name}</p></Col>
                                            <Col span={4}><p>{data?.area || '---'}</p></Col>
                                            <Col span={3}><p>{data?.pincode || '---'}</p></Col>
                                            {
                                                filterValues?.type === 'invoice' ? <Col span={3} className={classes.textAlignRight}><p>₹ {currencyFormat(data.invoice)}</p></Col> : ''
                                            }

                                            <Col span={filterValues?.type === 'invoice' ? 5 : 8} className={classes.textAlignRight}><p>{`₹ ${currencyFormat(filterValues?.type === 'payment' ? data.invoice : data.balance)}`}</p></Col>
                                        </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                                {
                                    collectionData.length > 0 ? <Row className={clsx(classes.bill, 'no-break')}>
                                        <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total</h6></Col>
                                        <Col span={5} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}></p></Col>
                                        <Col span={4} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}></p></Col>
                                        <Col span={3} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}></p></Col>
                                        {
                                            filterValues?.type === 'invoice' ?
                                                <Col span={3} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(collectionData.reduce((n, { invoice }) => n + invoice, 0))}</p></Col> : ''}
                                        <Col span={filterValues?.type === 'invoice' ? 5 : 8} className={classes.textAlignRight}><p style={{ padding: "0 5px" }}>₹ {currencyFormat(filterValues?.type === 'payment' ? collectionData.reduce((n, { invoice }) => n + invoice, 0) : collectionData.reduce((n, { balance }) => n + balance, 0))}</p></Col>
                                    </Row> : null
                                }
                            </>
                        }

                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); }}
            />
        </>
    )
}